import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { CityPageLayout } from "@/components/CityPageLayout";
import { CITY_DATA } from "@/lib/city-content";
import { buildFaqPage, buildBreadcrumbs, buildCityServices, buildCityLocalBusiness } from "@/components/SchemaJsonLd";
import { SERVICE_PAGES } from "@/lib/service-content";

const data = CITY_DATA["chestermere-ab"];

export const Route = createFileRoute("/service-areas/chestermere-ab")({
  head: () => ({
    meta: [
      { title: `Epoxy Floor Coatings in ${data.name}, ${data.state} | MLC Epoxy Floors` },
      { name: "description", content: `Premium epoxy and polyaspartic floor coatings in ${data.name}, ${data.state}. Diamond-ground prep, 1-day install, fully insured. Free quotes.` },
      { property: "og:title", content: `Epoxy Floor Coatings in ${data.name}, ${data.state}` },
      { property: "og:description", content: `Premium epoxy floor coatings in ${data.name} — serving the ${data.region} with diamond-ground, polyaspartic-topped systems.` },
      { property: "og:url", content: "/service-areas/chestermere-ab" },
    ],
    links: [{ rel: "canonical", href: "/service-areas/chestermere-ab" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildCityLocalBusiness(data)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      ...buildCityServices({ name: data.name, state: data.state, slug: "chestermere-ab" }, Object.values(SERVICE_PAGES).map(s => ({ name: s.name, slug: s.slug, intro: s.intro }))).map(s => ({ type: "application/ld+json", children: JSON.stringify(s) })),
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" },
        { name: "Service Areas", href: "/service-areas" },
        { name: `${data.name}, ${data.state}`, href: `/service-areas/chestermere-ab` },
      ])) },
    ],
  }),
  component: () => <CityPageLayout {...data} />,
});
